// extracted by mini-css-extract-plugin
export default {"form":"sign-up_form__sOpJg"};